import { Chip as MChip, Grid, Stack, styled } from "@mui/material";
import React from "react";
import { Card, IconButton, Title, Tooltip } from "../../components";
import { Field } from "../../components/presentation";
import formatters from "../../utils/formatters";
import { PENSIONISTAS } from "../../constants/generic.constants";
import { transformFromDate, transformToDate } from "../../utils/basic";
import { Edit } from "@mui/icons-material";
import AlterarInputPropostaDialogConnected from "../workflow/AlterarInputPropostaDialog.connected";
import { actions } from "../../actions/workflow.actions";

const Chip = styled(MChip)`
  margin-top: 0.25rem;
  padding: 0 0.25rem;

  & .MuiChip-label {
    font-family: ${({ theme }) => theme.fonts.family.default};
    font-size: ${({ theme }) => theme.fonts.size.small};
  }

  & + & {
    margin-left: 0.5rem;
  }
`;
const StyledIconButton = styled(IconButton)`
  padding: 0;
  color: ${({ theme }) => theme.colors.secondary._500};

  &.Mui-disabled {
    background-color: ${({ theme }) => theme.colors.grey._100};
  }
  & .MuiSvgIcon-root {
    font-size: 1rem;
  }
`;

const DadosClienteTab = ({ data, dominios, handleEditar }) => {
  return <DadosParticipante data={data} dominios={dominios} operacao={data} handleEditar={handleEditar}/>;
};

const StructuredField = ({ xs, sm, md, lg, xl, value, ...other }) => {
  if (
    !other.force &&
    (value === null ||
      value === undefined ||
      value === "" ||
      value?.length === 0)
  ) {
    return null;
  }

  return (
    <Grid item xs={xs} sm={sm} md={md} lg={lg} xl={xl}>
      <Field {...other} value={value} />
    </Grid>
  );
};

const DadosParticipante = ({ data, dominios, operacao, handleEditar }) => {
  return (
    <Grid item xs={12}>
      <Card>
        <Grid container spacing={2}>
          <Grid item xs={12} display={'flex'} flexDirection={'row'} alignItems={'center'} gap={2}>
            <Title as={"h3"}>Dados do Cliente</Title>
            <Tooltip arrow title={"Editar informações"}>
              <StyledIconButton
                loaderColor={"grey"}
                onClick={handleEditar}
              >
                <Edit />
              </StyledIconButton>
            </Tooltip>
          </Grid>
          <StructuredField
            xs={12}
            lg={4}
            xl={3}
            label={"CPF/CNPJ"}
            type={"cpfCnpj"}
            value={data?.cpfCnpj}
          />
          <StructuredField
            xs={12}
            lg={4}
            xl={3}
            label={"Nome"}
            value={data?.nome}
          />
          <StructuredField
            xs={12}
            lg={4}
            xl={3}
            label={"E-mail"}
            value={data?.email}
          />
          <StructuredField
            xs={12}
            lg={4}
            xl={3}
            label={"Celular"}
            value={data?.telefone}
          />
          {data?.principal && (
            <StructuredField
              xs={12}
              lg={4}
              xl={3}
              force
              label={"É correntista?"}
              type={"boolean"}
              value={operacao.detalhe?.correntista}
            />
          )}
          <StructuredField
            xs={12}
            lg={4}
            xl={3}
            label={"Telefone Residencial"}
            value={data?.telefoneResidencial}
          />
          <StructuredField
            xs={12}
            xl={6}
            label={"Endereço"}
            value={formatters.strings.address(data?.endereco)}
          />
          <StructuredField
            xs={12}
            lg={4}
            xl={3}
            label={"Tipo de Residência"}
            value={data?.endereco?.tipoResidencia?.id}
            type={"lookup"}
            domain={{
              data: dominios?.tipoResidencia,
              filter: (x, v) => x.id === v,
              map: (x) => x?.descricao,
            }}
          />
          <StructuredField
            xs={12}
            lg={4}
            xl={3}
            label={"Pessoa Politicamente Exposta?"}
            type={"boolean"}
            value={data?.ppe}
          />
          <StructuredField
            xs={12}
            lg={4}
            xl={3}
            label={"US Person?"}
            type={"boolean"}
            value={data?.usPerson}
          />
          <StructuredField
            xs={12}
            lg={4}
            xl={3}
            label={"Residente Fiscal no Brasil?"}
            type={"boolean"}
            value={data?.residenciaFiscalBrasil}
          />
          <StructuredField
            xs={12}
            lg={4}
            xl={3}
            label={"Participação Societária"}
            type={"percent"}
            value={data?.participacaoSocietaria}
          />
          <StructuredField
            xs={12}
            lg={4}
            xl={3}
            label={"Banco"}
            type={"lookup"}
            value={data?.bancoConta}
            domain={{
              data: dominios?.banco,
              filter: (x, v) => x.id === v,
              map: (x) => x?.nome,
            }}
          />
          <StructuredField
            xs={12}
            lg={4}
            xl={3}
            label={"CEP da Agência"}
            type={"zipcode"}
            value={data?.cepAgencia}
          />
          <StructuredField
            xs={12}
            lg={4}
            xl={3}
            label={"Agência Conta"}
            value={data?.agenciaConta}
          />
          <StructuredField
            xs={12}
            lg={4}
            xl={3}
            label={"Número Conta"}
            value={data?.numeroConta}
          />

          {data?.cpfCnpj.length <= 11 && (
            <DadosParticipantePf data={data} dominios={dominios} />
          )}
          {data?.tipoPessoa === "J" && (
            <DadosParticipantePj data={data} dominios={dominios} />
          )}
        </Grid>
      </Card>
    </Grid>
  );
};

const DadosParticipantePj = ({ data, dominios }) => {
  return (
    <>
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        label={"Faturamento Anual"}
        type={"currency"}
        value={data?.faturamentoAnual}
      />
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        label={"Tipo de Empresa"}
        type={"lookup"}
        value={data?.tipoEmpresa}
        domain={{
          data: dominios?.tipoEmpresa,
          filter: (x, v) => x.id === v,
          map: (x) => x?.descricao,
        }}
      />
    </>
  );
};

const DadosParticipantePf = ({ data, dominios }) => {
  return (
    <>
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        label={"Data de nascimento"}
        value={transformFromDate(data?.dataNascimento)}
      />
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        label={"Naturalidade"}
        value={data?.naturalidade}
      />
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        label={"Gênero"}
        type={"lookup"}
        value={data?.genero}
        domain={{
          data: dominios?.genero,
          filter: (x, v) => x.id === v,
          map: (x) => x?.descricao,
        }}
      />
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        label={"Escolaridade"}
        type={"lookup"}
        value={data?.escolaridade}
        domain={{
          data: dominios?.escolaridade,
          filter: (x, v) => x.id === v,
          map: (x) => x?.descricao,
        }}
      />
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        label={"Nacionalidade"}
        type={"lookup"}
        value={data?.nacionalidade}
        domain={{
          data: dominios?.nacionalidade,
          filter: (x, v) => x.id === v,
          map: (x) => x?.descricao,
        }}
      />
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        label={"Documento Pessoal"}
        type={"lookup"}
        value={data?.documentoPessoal}
        domain={{
          data: dominios?.documentoPessoal,
          filter: (x, v) => x.id === v,
          map: (x) => x?.descricao,
        }}
      />
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        label={"Número do Documento"}
        value={data?.numeroDocumentoPessoal}
      />
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        label={"Órgão de Expedição do Documento"}
        value={data?.orgaoDocumentoPessoal}
      />
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        label={"UF de Expedição do Documento"}
        value={data?.ufOrgaoDocumentoPessoal}
      />
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        label={"Data de Expedição do Documento"}
        value={transformFromDate(data?.dataExpedicaoDocumentoPessoal)}
      />
      <StructuredField
        xs={12}
        lg={8}
        xl={6}
        label={"Nome da Mãe"}
        value={data?.nomeMae}
      />
      <DadosProfissionais
        data={data}
        data2={data?.dadosProfissionais}
        dominios={dominios}
      />
      <DadosEstadoCivil data={data} dominios={dominios} />
      {data?.tipoParticipante === "VD" ? (
        <DadosContaDeLiberacao data={data} dominios={dominios} />
      ) : null}
    </>
  );
};

const DadosProfissionais = ({ data, data2 = {}, dominios }) => {
  let withValue = false;

  for (const v of ["perfilRenda", "renda", "patrimonio"]) {
    withValue |= Boolean(data[v]);
    if (withValue) break;
  }

  const data2Fields = [
    "dataAdmissao",
    "nomeEmpresa",
    "cnpjEmpresa",
    "cargo",
    "profissao",
    "faturamentoMensal",
    "tipoImovelAluguel",
    "quantidadeImoveisLocados",
    "tipoPensionista",
    "tipoPensao",
    "segmentoServico",
    "possuiContratoServico",
  ];

  if (!withValue) {
    for (const v of data2Fields) {
      withValue |= Boolean(data2[v]);
      if (withValue) break;
    }
  }

  if (!withValue) {
    return null;
  }

  return (
    <>
      <Grid item xs={12}>
        <Title as={"h5"} _margin_={"0.5rem 0 0 0"}>
          Dados Profissionais
        </Title>
      </Grid>
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        label={"Perfil de Renda"}
        type={"lookup"}
        value={data?.perfilRenda}
        domain={{
          data: dominios?.perfilRenda,
          filter: (x, v) => x.id === v,
          map: (x) => x?.descricao,
        }}
      />
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        label={"Renda"}
        type={"currency"}
        value={data?.renda}
      />
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        label={"Patrimônio"}
        type={"currency"}
        value={data?.patrimonio}
      />
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        label={"Data de Início"}
        value={transformFromDate(data2.dataAdmissao)}
      />
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        label={"Nome da Empresa"}
        value={data2.nomeEmpresa}
      />
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        label={"CNPJ da Empresa"}
        type={"cnpj"}
        value={data2.cnpjEmpresa}
      />
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        label={"Cargo"}
        value={data2.cargo}
      />
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        label={"Profissão"}
        type={"lookup"}
        value={data2.profissao}
        domain={{
          data: dominios?.profissao,
          filter: (x, v) => x.id === v,
          map: (x) => x?.descricao,
        }}
      />
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        label={"Faturamento Mensal"}
        type={"currency"}
        value={data2.faturamentoMensal}
      />
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        label={"Tipo de Imóvel de Aluguel"}
        type={"lookup"}
        value={data2.tipoImovelAluguel}
        domain={{
          data: dominios?.tipoImovelAluguel,
          filter: (x, v) => x.id === v,
          map: (x) => x?.descricao,
        }}
      />
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        label={"Quantidade de Imóveis Locados"}
        value={data2.quantidadeImoveisLocados}
      />
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        label={"Ramo de Atuação"}
        type={"lookup"}
        value={data2.ramoAtuacao}
        domain={{
          data: dominios?.ramoAtuacao,
          filter: (x, v) => x.id === v,
          map: (x) => x?.descricao,
        }}
      />
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        label={"Pensionista/Aposentado?"}
        value={PENSIONISTAS[data2.tipoPensionista]}
      />
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        label={"Tipo de Pensão"}
        type={"lookup"}
        value={data2.tipoPensao}
        domain={{
          data: dominios?.tipoPensao,
          filter: (x, v) => x.id === v,
          map: (x) => x?.descricao,
        }}
      />
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        label={"Segmento do Servico"}
        type={"lookup"}
        value={data2.segmentoServico}
        domain={{
          data: dominios?.segmentoServico,
          filter: (x, v) => x.id === v,
          map: (x) => x?.descricao,
        }}
      />
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        label={"Possui Contrato de Prestação de Serviço?"}
        type={"boolean"}
        value={data2.possuiContratoServico}
      />
    </>
  );
};

const DadosEstadoCivil = ({ data, dominios }) => {
  let withValue = false;

  for (const v of [
    "estadoCivil",
    "uniaoEstavel",
    "regimeComunhao",
    "dataCasamento",
  ]) {
    withValue |= data[v];
    if (!!withValue) {
      break;
    }
  }

  if (!withValue) {
    return null;
  }

  return (
    <>
      <Grid item xs={12}>
        <Title as={"h5"} _margin_={"0.5rem 0 0 0"}>
          Dados Estado Civil
        </Title>
      </Grid>
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        label={"Estado Civil"}
        type={"lookup"}
        value={data?.estadoCivil}
        domain={{
          data: dominios?.estadoCivil,
          filter: (x, v) => x.id === v,
          map: (x) => x?.descricao,
        }}
      />
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        label={"União estável?"}
        type={"boolean"}
        value={data?.uniaoEstavel}
      />
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        label={"Regime de Comunhão"}
        type={"lookup"}
        value={data?.regimeComunhao}
        domain={{
          data: dominios?.regimeComunhao,
          filter: (x, v) => x.id === v,
          map: (x) => x?.descricao,
        }}
      />
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        label={"Data do Casamento"}
        value={transformFromDate(data?.dataCasamento)}
      />

      {!!data?.conjuge && (
        <DadosConjuge data={data?.conjuge} dominios={dominios} />
      )}
    </>
  );
};

const DadosContaDeLiberacao = ({ data, dominios }) => {
  return (
    <>
      {data?.contaLiberacao ? (
        <Grid item xs={12}>
          <Title as={"h5"} _margin_={"0.5rem 0 0 0"}>
            Conta de Liberação
          </Title>
        </Grid>
      ) : null}
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        force
        label={"Banco"}
        type={"lookup"}
        value={data?.contaLiberacao?.bancoConta}
        domain={{
          data: dominios?.banco,
          filter: (x, v) => x.id === v,
          map: (x) => x?.nome,
        }}
      />
      {data?.contaLiberacao && (
        <StructuredField
          xs={12}
          lg={4}
          xl={3}
          force
          label={"Agência / Conta"}
          value={`${data?.contaLiberacao?.agenciaConta} / ${data?.contaLiberacao?.numeroConta}`}
        />
      )}
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        force
        label={"Tipo"}
        type={"lookup"}
        value={data?.contaLiberacao?.tipoConta}
        domain={{
          data: dominios?.tipoConta,
          filter: (x, v) => x.id === v,
          map: (x) => x?.descricao,
        }}
      />
    </>
  );
};

const DadosConjuge = ({ data, dominios, participanteOrigem }) => {
  return (
    <>
      <Grid item xs={12}>
        <Title as={"h5"} _margin_={"0.5rem 0 0 0"}>
          Cônjuge
        </Title>
      </Grid>
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        label={"CPF"}
        type={"cpf"}
        value={data?.cpfCnpj}
      />
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        label={"Nome"}
        value={data?.nome}
      />
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        label={"E-mail"}
        value={data?.email}
      />
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        label={"Celular"}
        value={data?.telefone}
      />
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        label={"Data de nascimento"}
        value={transformFromDate(data?.dataNascimento)}
      />
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        label={"Gênero"}
        type={"lookup"}
        value={data?.genero}
        domain={{
          data: dominios?.genero,
          filter: (x, v) => x.id === v,
          map: (x) => x?.descricao,
        }}
      />
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        label={"Nacionalidade"}
        type={"lookup"}
        value={data?.nacionalidade}
        domain={{
          data: dominios?.nacionalidade,
          filter: (x, v) => x.id === v,
          map: (x) => x?.descricao,
        }}
      />

      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        label={"Estado Civil"}
        type={"lookup"}
        value={data?.estadoCivil}
        domain={{
          data: dominios?.estadoCivil,
          filter: (x, v) => x.id === v,
          map: (x) => x?.descricao,
        }}
      />
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        label={"Documento Pessoal"}
        type={"lookup"}
        value={data?.documentoPessoal}
        domain={{
          data: dominios?.documentoPessoal,
          filter: (x, v) => x.id === v,
          map: (x) => x?.descricao,
        }}
      />
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        label={"Número do Documento"}
        value={data?.numeroDocumentoPessoal}
      />
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        label={"Órgão de Expedição do Documento"}
        value={data?.orgaoDocumentoPessoal}
      />
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        label={"UF de Expedição do Documento"}
        value={data?.ufOrgaoDocumentoPessoal}
      />
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        label={"Data de Expedição do Documento"}
        value={transformFromDate(data?.dataExpedicaoDocumentoPessoal)}
      />
      <StructuredField
        xs={12}
        lg={4}
        xl={3}
        label={"Qualificação"}
        type={"lookup"}
        value={data?.qualificacao}
        domain={{
          data: dominios?.qualificacao,
          filter: (x, v) => x.id === v,
          map: (x) => x?.descricao,
        }}
      />

      {!!participanteOrigem && (
        <>
          <StructuredField
            xs={12}
            lg={4}
            xl={3}
            label={"Compoe Quadro Societário?"}
            type={"boolean"}
            value={data?.compoeQuadroSocietario}
          />
          <StructuredField
            xs={12}
            lg={4}
            xl={3}
            label={"Participação Societária"}
            type={"percent"}
            value={data?.participacaoSocietaria}
          />
        </>
      )}
      <DadosProfissionais data={data} data2={data} dominios={dominios} />
    </>
  );
};

export default DadosClienteTab;
